import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { SkipLink } from './SkipTo.styles.js';

var SkipTo = function SkipTo(_a) {
  var _b = _a.elementClick,
      elementClick = _b === void 0 ? false : _b,
      selector = _a.selector,
      text = _a.text,
      props = __rest(_a, ["elementClick", "selector", "text"]);

  var handleSkip = function handleSkip(e) {
    e.preventDefault();
    var element = document.querySelector(selector);

    if (element) {
      element.focus();
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      elementClick && element.click();
    }
  };

  return React.createElement(SkipLink, __assign({
    href: "#",
    onClick: handleSkip
  }, props), text);
};

export { SkipTo };